import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { isOnboardingComplete } from "../../Utils/onboardingNavigation";
import CoachPrivateV2 from "../CoachV2/Private";
import OnboardingQRPage from "./OnboardingQRPage";
import TalkItThrough from "./TalkItThrough";

/**
 * The Aris tab.
 *
 *   (none)      the Voice/Text chooser — Figma node 9384:2925
 *   ?mode=voice the voice session, started on mount
 *
 * Text is not a mode here: the chooser sends it to /chat, the conversation view
 * itself. Routing it through this page would mean rendering DashboardChat, whose
 * greeting-and-prompt screen is the extra step being removed.
 *
 * Voice's mode lives in the query string rather than local state so the browser
 * back button returns to the chooser. /dashboard/voice and /dashboard/text are
 * deprecated — see AppRoutes.
 */
function Dashboard() {
  const [searchParams] = useSearchParams();

  const profile = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("profile") || "{}"); } catch (_) { return {}; }
  }, []);

  const completedSteps = profile?.onboarding_step;

  // If onboarding not complete, show QR page with navigation (allows logout)
  if (completedSteps && !isOnboardingComplete(completedSteps)) {
    return <OnboardingQRPage />;
  }

  const mode = searchParams.get("mode");

  // Voice asks ArisCoach to open the session immediately, so the member's single
  // tap on the chooser is the only one needed.
  if (mode === "voice") {
    return <CoachPrivateV2 autoStart />;
  }

  // Any other mode — including a stale ?mode=text link — falls through to the
  // chooser. Deliberately not a redirect to /chat: /chat's back button returns
  // here, and a redirect would bounce the member straight forward again.
  return <TalkItThrough />;
}

export default Dashboard;
